export const messages = {
  rules: [
    'El centro de costos no debe tener saldo.',
    'No debe haber tarjetas que dependan del centro de costos que tengan saldo disponible. Asegúrese que la lista de la sección tarjetas con saldo esté vacía.',
    'No debe haber centros de costos que dependan del centro de costos que usted está intentando mover que tengan saldo disponible. Asegúrese que la lista de la sección centros de costos con saldo se encuentre vacía.',
  ],
};
